/**
 * Sorts objects based on their status property according to a predefined order.
 *
 * @param a - First object containing a status property
 * @param b - Second object containing a status property
 * @returns
 *  - Negative number if a's status should come before b's status
 *  - Zero if statuses are equal
 *  - Positive number if a's status should come after b's status
 *
 * Status Priority:
 * 1. accept
 * 2. pending
 * 3. reject
 * Any other status will be given lowest priority (999)
 */

export const sortByStatus = (a: {status: string}, b: {status: string}) => {
  const statusOrder = {
    accept: 1,
    pending: 2,
    reject: 3,
  };

  const statusA = statusOrder[a.status as keyof typeof statusOrder] || 999;
  const statusB = statusOrder[b.status as keyof typeof statusOrder] || 999;

  return statusA - statusB;
};
